import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="bar-chart"
export default class extends Controller {
  static targets = ["bar", "segment"]

  connect() {
    this.setHeights()
  }

  setHeights() {
    this.barTargets.forEach((el) => {
      const pct = parseFloat(el.dataset.barHeight) || 0
      el.style.height = (pct > 0 ? Math.max(pct, 5) : 0) + "%"
    })

    this.segmentTargets.forEach((el) => {
      el.style.height = parseFloat(el.dataset.segmentPct) + "%"
    })
  }
}
